import {useClientFetch} from "~/composables/useClientFetch.js";

export default {
    index() {
        return useClientFetch('/cart/').data;
    },
    async storeUpdate(product_id, quantity, key, silent = false) {
        const url = silent ? 'cart/silent' : 'cart';
        const response = await useClientFetch(url,
            {
                method: 'POST',
                body: {product_id, quantity, 'cart-key': key}
            });

        //update dataLayer
        if (response?.data?.dataLayer) {
            gtm.push(response.data.dataLayer);
        }

        const { $emitter } = useNuxtApp();
        $emitter.emit('cart-updated');

        return response;
    },
    async silentStore(product_id, quantity, key) {
        const response = await useClientFetch('cart/silent',
            {
                method: 'POST',
                body: {product_id, quantity, 'cart-key': key}
            });

        if (response?.data?.dataLayer) {
            gtm.push(response.data.dataLayer);
        }

        const { $emitter } = useNuxtApp();
        $emitter.emit('cart-updated');

        return response;
    },
    async destroy(product_id, key) {
        const response = await useClientFetch(`cart/${product_id}?cart-key=${key}`,
            {
                method: 'DELETE',
            });

        //update dataLayer
        if (response?.data?.dataLayer) {
            gtm.push(response.data.dataLayer);
        }

        return response;
    },
    async multipleDestroy(ids, key) {
        const response = await useClientFetch(`cart?cart-key=${key}`, {
            method: 'DELETE',
            body: { ids }
        });

        if (response?.data?.dataLayers && Array.isArray(response.data.dataLayers)) {
            response.data.dataLayers.forEach(dataLayer => {
                gtm.push(dataLayer);
            });
        }

        return response;
    }
};
